export enum SubscriptionStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Expired = 'expired',
  Future = 'future',
  Inactive = 'inactive',
  InTrial = 'inTrial',
  NonRenewing = 'nonRenewing',
}
